/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shopping_Have_It_DoneInputs */

const en_shopping_have_it_done = /** @type {(inputs: Shopping_Have_It_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: already at home`)
};

const de_shopping_have_it_done = /** @type {(inputs: Shopping_Have_It_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: schon zu Hause`)
};

/**
* | output |
* | --- |
* | "{name}: already at home" |
*
* @param {Shopping_Have_It_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_have_it_done = /** @type {((inputs: Shopping_Have_It_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Have_It_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_have_it_done(inputs)
	return en_shopping_have_it_done(inputs)
});